export const SPACING_TOKENS = {
  0: '0px',
  2: '2px',
  4: '4px',
  6: '6px',
  8: '8px',
  12: '12px',
  16: '16px',
  20: '20px',
  24: '24px',
  32: '32px',
  40: '40px',
  48: '48px',
  64: '64px',
  80: '80px',
} as const;

export type SpacingTokens = typeof SPACING_TOKENS;
export type SpacingTokenKey = keyof SpacingTokens;
export type SpacingTokenValue = SpacingTokens[SpacingTokenKey];
